import { render, staticRenderFns } from "./UnidadeForm.vue?vue&type=template&id=3c472fae"
import script from "./UnidadeForm.vue?vue&type=script&lang=js"
export * from "./UnidadeForm.vue?vue&type=script&lang=js"
import style0 from "./UnidadeForm.vue?vue&type=style&index=0&id=3c472fae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports